<template>
    <div class="account">
        <!-- 流向的供方 -->
        <vFlowSupplierListComponent :postList="postList" v-if="flag"></vFlowSupplierListComponent>
    </div>
</template>
<script>
import vFlowSupplierListComponent from '../../listComponent/basicdata/flowSourceLists/flowSupplierListComponent.vue';
export default {
    name: 'flowSupplierList',
    components: {
        vFlowSupplierListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: true,
                source_file: true,
                batchSaveBtn: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>